import React, { Fragment, memo } from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { Button } from './Button'

interface FileViewerFallbackContentProps {
  onOpenInTab: () => void
}

const FileViewerFallbackContentComponent = ({ onOpenInTab }: FileViewerFallbackContentProps) => {
  return (
    <Fragment>
      <Typography variant="body2" color="textSecondary" component="p">
        Your browser couldn't preview this file. Please try a different browser or click the button
        below to open it in a new tab
      </Typography>
      <Button
        data-testid="customer-interface-file-open-in-tab-btn"
        color="white"
        size="small"
        className={tw`rounded-lg`}
        onClick={onOpenInTab}
      >
        Open in new tab
      </Button>
    </Fragment>
  )
}

export const FileViewerFallbackContent = memo(FileViewerFallbackContentComponent)
